/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var BlockTypes = /** @class */ (function () {
    function BlockTypes() {
    }
    BlockTypes.blockTypeMultiSelect = "MultiOptionSetFormField";
    BlockTypes.blockTypePurpose = "Consent";
    BlockTypes.blockTypeTopic = "Topic";
    BlockTypes.blockTypeSessions = "Sessions";
    return BlockTypes;
}());
export { BlockTypes };
